<template>
	<el-menu :default-active="route.meta.menuId" class="layout-menu" :collapse="isCollapse" menu-trigger="click" @open="handleOpen" @close="handleClose">
		<LayoutMenuItem v-for="menu in validMenus" :key="menu.meta.menuId" :menu="menu"></LayoutMenuItem>
	</el-menu>
</template>
<script lang="ts" setup name="LayoutMenu">
import LayoutMenuItem from './LayoutMenuItem.vue'
import { usePermissionStore } from '@/store/permission'
import { useRoute } from 'vue-router'

const route = useRoute()
const permissionStore = usePermissionStore()
const isCollapse = ref(true)
// computed name validMenus
const validMenus = computed(() => {
	return permissionStore.hamMenus.filter(menu => {
		return menu.path || menu.children.length
	})
})
const handleOpen = (key: string, keyPath: string[]) => {
	// console.log(key, keyPath)
}
const handleClose = (key: string, keyPath: string[]) => {
	// console.log(key, keyPath)
}
</script>

<style lang="scss" scoped>
.el-menu {
	border-right: none;
	&-vertical:not(.el-menu--collapse) {
		width: 200px;
		min-height: 400px;
	}
	.el-sub-menu__title {
		padding: 0;
	}
	:deep(.el-menu-tooltip__trigger) {
		padding: 0;
		> a {
			justify-content: center;
		}
	}
}
</style>
<style lang="scss">
.el-popper {
	.el-menu-item {
		padding: 0;
		> a {
			padding: 0 20px;
		}
	}
}
</style>
